import { Link } from 'react-router-dom';

export default function About() {
  return (
    <div className="max-w-3xl mx-auto px-4 py-8">
      <h1 className="text-2xl font-bold text-center mb-6">关于本站</h1>

      <div className="space-y-5 text-gray-700 leading-relaxed">
        {/* 简介 */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <p className="mb-3">
            <strong className="text-gray-900 text-lg">围棋棋谱检索网</strong>是一个专注于围棋棋谱收集、整理与分享的网站，收录了中今中外大量高水平对局棋谱，涵盖国内外各大棋战。也包含部分职业与业余高手的网棋棋谱，还有爱奇围棋，KaTaGo等围棋AI的棋谱。
          </p>
          <p>
            本站致力于为围棋爱好者提供便捷的棋谱检索与在线打谱体验，所有棋谱均可在线浏览，支持逐手推演，帮助棋友复盘学习、提升棋力。今后陆续再增加摆参考图，上传用户棋谱，AI辅助研究等功能。
          </p>
        </div>

        {/* 收录范围 */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
            <span className="w-1 h-5 bg-blue-500 rounded-full inline-block"></span>
            收录范围
          </h2>
          <ul className="space-y-2 pl-1">
            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-2 h-2 bg-blue-400 rounded-full flex-shrink-0"></span>
              <span>中日韩国际棋战对局</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-2 h-2 bg-blue-400 rounded-full flex-shrink-0"></span>
              <span>中国围甲联赛及国内大赛</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-2 h-2 bg-blue-400 rounded-full flex-shrink-0"></span>
              <span>韩国围棋联赛及头衔战</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-2 h-2 bg-blue-400 rounded-full flex-shrink-0"></span>
              <span>日本七大棋战及名人战</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-2 h-2 bg-blue-400 rounded-full flex-shrink-0"></span>
              <span>历代名局及古谱</span>
            </li>
            <li className="flex items-start gap-2">
              <span className="mt-1.5 w-2 h-2 bg-green-400 rounded-full flex-shrink-0"></span>
              <span>部分网棋对局</span>
            </li>
          </ul>
        </div>

        {/* 功能特色 */}
        <div className="bg-white rounded-lg shadow-md p-6">
          <h2 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
            <span className="w-1 h-5 bg-amber-500 rounded-full inline-block"></span>
            功能特色
          </h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <div className="flex items-start gap-3 bg-amber-50 rounded-lg p-3">
              <span className="text-xl">🔍</span>
              <span>按棋手、比赛名称等多维度检索</span>
            </div>
            <div className="flex items-start gap-3 bg-amber-50 rounded-lg p-3">
              <span className="text-xl">♟️</span>
              <span>在线棋盘逐手打谱，支持前进后退跳转</span>
            </div>
            <div className="flex items-start gap-3 bg-amber-50 rounded-lg p-3">
              <span className="text-xl">💾</span>
              <span>SGF棋谱下载，支持离线研究</span>
            </div>
            <div className="flex items-start gap-3 bg-amber-50 rounded-lg p-3">
              <span className="text-xl">🔄</span>
              <span>棋谱持续增补更新</span>
            </div>
          </div>
        </div>

        {/* 联系我们 */}
        <div className="bg-gradient-to-r from-blue-50 to-indigo-50 rounded-lg shadow-md p-6">
          <h2 className="text-lg font-bold text-gray-800 mb-3 flex items-center gap-2">
            <span className="w-1 h-5 bg-indigo-500 rounded-full inline-block"></span>
            联系我们
          </h2>
          <div className="flex items-center gap-3 mb-2">
            <span className="bg-white rounded-full w-8 h-8 flex items-center justify-center text-sm shadow-sm">👤</span>
            <span>站长大肖联系方式：<strong className="text-indigo-600">QQ：86575493</strong></span>
          </div>
          <p className="text-gray-600 ml-11">
            如有任何建议或问题，也欢迎通过<a href="/guestbook/" className="text-blue-600 hover:underline font-medium">留言板</a>沟通交流。
          </p>
        </div>
      </div>

      <div className="text-center mt-6">
        <Link to="/" className="text-blue-600 hover:underline">← 返回首页</Link>
      </div>
    </div>
  );
}
